import { ChevronRight } from "lucide-react"
import type { ReactNode } from "react"

/**
 * A full translation of an article, collapsed under a one-line toggle so the
 * English stays the default reading (the GitHub blog's "Leia este artigo em
 * português" pattern). `lang` marks the expanded text for screen readers and
 * search engines.
 */
export function Translation({
  summary,
  lang,
  children,
}: {
  summary: string
  lang: string
  children: ReactNode
}) {
  return (
    <details className="group my-8 rounded-lg border border-(--border-default) bg-raised">
      <summary className="flex cursor-pointer list-none items-center gap-2 px-5 py-4 font-medium text-default [&::-webkit-details-marker]:hidden">
        <ChevronRight
          aria-hidden="true"
          className="size-4 shrink-0 text-muted transition-transform group-open:rotate-90"
        />
        {summary}
      </summary>
      <div lang={lang} className="border-t border-(--border-default) px-5 pb-2">
        {children}
      </div>
    </details>
  )
}
